import { render, staticRenderFns } from "./TableAction.vue?vue&type=template&id=5cbeedd3&scoped=true&"
import script from "./TableAction.vue?vue&type=script&lang=js&"
export * from "./TableAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbeedd3",
  null
  
)

export default component.exports